import React from 'react';

import styled, { css } from 'styled-components';

import { IPickerAspectUiPattern } from '@rbi-ctg/menu';
import { Calories } from 'components/price-and-calories';
import { isUiPatternRadio } from 'state/menu/types';

import { CaloriesWrapper } from './calories';
import { Name } from './name';
import { INameAndCalories } from './types';

const IconWrap = styled.div<IPickerAspectUiPattern>`
  display: none;

  ${p =>
    isUiPatternRadio(p) &&
    css`
      display: block;
      height: 35px;
      margin: 0 auto 5px auto;

      > svg {
        height: 100%;
      }

      ${Styles.desktop`
        height: 45px;
      `}
    `}
`;

const noop = () => null;

export default function NameAndCalories(props: INameAndCalories) {
  const Icon = props.icon || noop;
  return (
    <div>
      <IconWrap uiPattern={props.uiPattern}>
        <Icon stroke={props.selected ? Styles.color.primary : Styles.color.black} />
      </IconWrap>
      <Name>{props.name}</Name>
      <Calories>
        <CaloriesWrapper uiPattern={props.uiPattern}>{props.calories}</CaloriesWrapper>
      </Calories>
    </div>
  );
}
